/* eslint-disable */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDProgress from "components/MDProgress";

// Images
import logoXD from "assets/images/small-logos/logo-xd.svg";
import logoAtlassian from "assets/images/small-logos/logo-atlassian.svg";
import logoSlack from "assets/images/small-logos/logo-slack.svg";
import logoSpotify from "assets/images/small-logos/logo-spotify.svg";
import logoJira from "assets/images/small-logos/logo-jira.svg";
import logoInvesion from "assets/images/small-logos/logo-invision.svg";
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Diversity2Rounded } from "@mui/icons-material";

export default function data() {

  const [departmentsList, setDepartmentsList] = useState(null);
  const [deptRows, setDeptRows] = useState([]);

  const getAllDepartments = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAllDepartments");
      const data = await response.json();
      setDepartmentsList(data);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera DepartmentsList:", error);
      toast.error(`Błąd podczas pobierania danych z serwera DepartmentsList: ${error}`);
      setDepartmentsList(null);
    }
  };

  useEffect(() => {
    getAllDepartments();
  }, []);

  const avatars = (members) =>
    members.map(([image, name]) => (
      <Tooltip key={name} title={name} placeholder="bottom">
        <MDAvatar
          src={image}
          alt="name"
          size="xs"
          sx={{
            border: ({ borders: { borderWidth }, palette: { white } }) =>
              `${borderWidth[2]} solid ${white.main}`,
            cursor: "pointer",
            position: "relative",

            "&:not(:first-of-type)": {
              ml: -1.25,
            },

            "&:hover, &:focus": {
              zIndex: "10",
            },
          }}
        />
      </Tooltip>
    ));

  const Company = ({ name }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      {/* <MDAvatar src={image} name={name} size="sm" /> */}
      <Diversity2Rounded fontSize="medium" />
      <MDTypography variant="button" fontWeight="medium" ml={1} lineHeight={1}>
        {name}
      </MDTypography>
    </MDBox>
  );

  useEffect(()=>{
    departmentsList !== null && departmentsList.map((department)=>(
      deptRows.push(
        {
          companies: <Company name={department.name} />,
        },
      )
    ))
  },[departmentsList])

  return {
    columns: [
      { Header: "Nazwa działu", accessor: "companies", width: "45%", align: "left" },
    ],
    rows: deptRows.length === 0 ? [] : deptRows
  };
}
